module.exports = __webpack_public_path__ + "img/黄山药.3d5e4e44.jpg";